module.exports = __webpack_public_path__ + "img/maketwo.0540858d.png";